// Import the Commerce module
import Commerce from '@chec/commerce.js';

// Create a Commerce instance
 export const commerce = new Commerce('pk_47547f71f2fe21e68cb5e708e9fb264e744b28679ad95');
